import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import {
  ManageTerminalsRootParamList,
  SettingsRootParamList,
} from "../../../../types";
import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import { ManageTerminalsScreen } from "./ManageTerminalsScreen";
import { EditTerminalScreen } from "./EditTerminalScreen";

const Stack = createStackHeaderNavigator<ManageTerminalsRootParamList>();

export interface ManageTerminalsRootScreenScreenProps
  extends StackScreenProps<
    SettingsRootParamList,
    "ManageTerminalsRootScreen"
  > {}

export const ManageTerminalsRootScreen =
  ({}: ManageTerminalsRootScreenScreenProps) => {
    return (
      <Stack.Navigator
        screenOptions={{
          animationEnabled: true,
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
        }}
      >
        <Stack.Group
          screenOptions={{
            title: "",
            headerLeft: () => <ModalCloseButton type="Back" />,
          }}
        >
          <Stack.Screen
            name="ManageTerminalsScreen"
            component={ManageTerminalsScreen}
          />
          <Stack.Screen
            name="EditTerminalScreen"
            component={EditTerminalScreen}
            options={{
              headerShown: false,
              title: "",
            }}
          />
        </Stack.Group>
      </Stack.Navigator>
    );
  };
